import moment from 'moment'

export const LAMENESS_VIDEO_MOCK_URL =
	'https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4'

export const LAMENESS_PHOTO_MOCK_URL =
	'https://upload.wikimedia.org/wikipedia/commons/thumb/8/8c/Cow_%28Fleckvieh_breed%29_Oeschinensee_Slaunger_2009-07-07.jpg/1280px-Cow_%28Fleckvieh_breed%29_Oeschinensee_Slaunger_2009-07-07.jpg'

const LAMENESS_VIDEO_RETENTION_DAYS = 7
const LAMENESS_VIDEO_MOCK_STORAGE_KEY = 'sf_mock_lameness_video'
const COWVISION_API = 'https://api.cowvision.ru/'

const isLamenessVideoMockAllowed = () =>
	process.env.NODE_ENV === 'development' ||
	process.env.REACT_APP_SERVER_NAME === COWVISION_API

export const getLamenessVideoMockMode = (): '1' | '2' | null => {
	if (typeof window === 'undefined' || !isLamenessVideoMockAllowed()) {
		return null
	}
	const fromQuery = new URLSearchParams(window.location.search).get(
		'lamenessVideoMock',
	)
	if (fromQuery === '1' || fromQuery === '2') return fromQuery

	const fromStorage = window.localStorage.getItem(
		LAMENESS_VIDEO_MOCK_STORAGE_KEY,
	)
	if (fromStorage === '1' || fromStorage === '2') return fromStorage
	return null
}

export const isLamenessVideoMockEnabled = () =>
	getLamenessVideoMockMode() != null

export const isLamenessVideoExpired = (trackingDt?: number | null) => {
	if (trackingDt == null) return false
	return (
		moment().diff(moment(trackingDt), 'days') > LAMENESS_VIDEO_RETENTION_DAYS
	)
}
